export default __webpack_public_path__ + "static/media/kh-homepage-bg.7c58e49c.png";